import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { Translate } from 'core/translate';
import NotificationsContext from '../../common/notifications/NotificationsContext';
import Currency from '../../common/intl/Currency';
import { Dagger } from '../../common/notifications/NotificationsTrigger';

const AccessoriesPriceContent = ({ value }) => {
  return (
    <NotificationsContext.Consumer>
      {({ disabled, showNamed }) => (
        <div className="accessories-price">
          <span
            className={`price accessories-price__total stat-disclaim ${
              disabled ? '' : 'disclaimer'
            }`}
            onClick={event => showNamed('accessories', event)}>
            +<Currency value={value} />{' '}
            {disabled ? null : (
              <Fragment>
                <Dagger className="accessories-price__dagger" />{' '}
              </Fragment>
            )}
          </span>
          {disabled ? null : (
            <div className="show-for-sr">
              <Translate value="accessories.price.disclaimer" />
            </div>
          )}
          <span className="accessories-price__label">
            <Translate value="accessories.price.label" />
          </span>
        </div>
      )}
    </NotificationsContext.Consumer>
  );
};

const AccessoriesPrice = ({ value }) => {
  return (
    <Route path="/accessories">
      {({ match }) => {
        if (match || value) {
          return <AccessoriesPriceContent value={value} />;
        }
        return null;
      }}
    </Route>
  );
};

export default AccessoriesPrice;
